// extracted by mini-css-extract-plugin
export default {"wrapper":"GroupBy_wrapper__s7K8m","over":"GroupBy_over__7sSm-","list":"GroupBy_list__yOGQ5"};